import { render } from "./RiskSummary.vue?vue&type=template&id=49c3c9db&scoped=true"
import script from "./RiskSummary.js?vue&type=script&lang=js"
export * from "./RiskSummary.js?vue&type=script&lang=js"

import "./RiskSummary.vue?vue&type=style&index=0&id=49c3c9db&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c3c9db"]])

export default __exports__